import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { UserService } from '../services/user.service';
import { LinkService } from '../services/link.service';
import { DisplayLinksPipe } from '../pipes/display-links.pipe';
import { DragulaModule } from 'ng2-dragula';
import { ColorPickerModule } from 'ngx-color-picker';


import { AppComponent } from './app.component';
import { LandingPage } from '../pages/landing/landing';
import { LoginPage } from '../pages/login/login';
import { CompletePage } from '../pages/complete/complete';
import { DisplayPage } from '../pages/display/display';
import { LinksPage } from '../pages/links/links';
import { PlansPage } from '../pages/plans/plans';
import { ContactPage } from '../pages/contact/contact';
import { SettingsPage } from '../pages/settings/settings';
import { AccountPage } from '../pages/account/account';
import { TeamPage } from '../pages/team/team';
import { NavbarComponent } from '../components/navbar/navbar';
import { ErrorPage } from '../pages/404/404';
import { TermsPage } from '../pages/terms/terms';
import { PrivacyPage } from '../pages/privacy/privacy';
import { AdminPage } from '../pages/admin/admin';

const appRoutes: Routes = [
  {
    path: '',
    component: LandingPage
  },
  {
    path: 'index',
    component: LandingPage
  },
  {
    path: 'index/:scrollTo',
    component: LandingPage
  },
  {
    path: 'login',
    component: LoginPage
  },
  {
    path: 'signup',
    component: LoginPage
  },
  {
    path: 'signup/complete',
    component: CompletePage
  },
  {
    path: 'signup/:verify',
    component: LoginPage
  },
  // {
  //   path: 'signup/:verify?mode=:mode&oobCode=:oobCode',
  //   component: LoginPage
  // },
  {
    path: 'contact',
    component: ContactPage
  },
  {
    path: 'display',
    component: DisplayPage
  },
  {
    path: 'display/:id',
    component: DisplayPage
  },
  {
    path: 'links',
    component: LinksPage
  },
  {
    path: 'l/:id',
    component: LinksPage
  },
  {
    path: 'settings',
    component: SettingsPage
  },
  {
    path: 'account',
    component: AccountPage
  },
  {
    path: 'team',
    component: TeamPage
  },
  {
    path: 'plans',
    component: PlansPage
  },
  {
    path: '404',
    component: ErrorPage
  },
  {
    path: 'terms',
    component: TermsPage
  },
  {
    path: 'privacy',
    component: PrivacyPage
  },
  {
    path: 'admin/:any',
    component: AdminPage
  },
  {
    path: ':username',
    component: DisplayPage
  },
  {
    path: '**',
    component: LandingPage
  }
];

@NgModule({
  declarations: [
    AppComponent,
    LandingPage,
    LoginPage,
    CompletePage,
    DisplayPage,
    LinksPage,
    PlansPage,
    ContactPage,
    SettingsPage,
    AccountPage,
    TeamPage,
    NavbarComponent,
    ErrorPage,
    TermsPage,
    PrivacyPage,
    AdminPage,
    DisplayLinksPipe,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
    ),
    FormsModule,
    DragulaModule,
    ColorPickerModule,
    HttpModule,
  ],
  providers: [UserService, LinkService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts